import firebase from 'firebase/app';
import 'firebase/firestore';
var firebaseConfig = {
    apiKey: "AIzaSyBT34TfR-8dlxZOIqU72Rc6Ahq-fws7ars",
    authDomain: "todo-ninja-f22a7.firebaseapp.com",
    databaseURL: "https://todo-ninja-f22a7.firebaseio.com",
    projectId: "todo-ninja-f22a7",
    storageBucket: "todo-ninja-f22a7.appspot.com",
    messagingSenderId: "208908404406",
    appId: "1:208908404406:web:a773b4010afafe7d468817"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
db.settings({ timestampsInSnapshots: true });

export default db;